export default "__VITE_ASSET__BSPyJDK6__"